import type { NavLink, NewsItem, TourDate, Track, Video, StreamingPlatform, SocialLink } from '../types'

// ── DJ Info ───────────────────────────────────────────────
export const DJ_NAME = 'DJ 30Rack'
export const DJ_TAGLINE = 'Spinning the soundtrack to America\'s wildest nights.'
export const DJ_GENRE = ['Country', 'Americana', 'Open Format']
export const DJ_BIO_SHORT = 'From honky-tonk dives to sold-out arenas — spinning the soundtrack to America\'s wildest nights.'
export const DJ_BIO_LONG = `Born and raised on country roads and late-night neon, DJ 30Rack has spent over a decade turning dusty venues into electric rooms and festival fields into family reunions.

Blending Country, and Americana with the raw energy of a full arena show, the sound is unmistakable — honest, crowd-moving, and built for a night nobody forgets.

Having shared the stage with country's biggest names and rocked massive events like Stagecoach, Country Thunder, and the Rock the Country Tour, DJ 30Rack brings the heat from the honky-tonks of Nashville to stages nationwide.

With 500+ shows played, 10M+ streams, and over a decade in the game, every set is custom-crafted for the room, the crowd, and the moment.`

export const DJ_STATS = [
  { value: '500+', label: 'Shows Played' },
  { value: '10M+', label: 'Streams' },
  { value: '12 Yrs', label: 'In The Game' },
]

// ── Navigation ────────────────────────────────────────────
export const NAV_LINKS: NavLink[] = [
  { label: 'Home', href: '/' },
  { label: 'News', href: '/news' },
  { label: 'Tour', href: '/tour' },
  { label: 'Bio', href: '/bio' },
  { label: 'Music', href: '/music' },
  { label: 'Videos', href: '/videos' },
  { label: 'Merch', href: '/merch', external: true },
  { label: 'EPK', href: '/epk' },
  { label: 'Contact', href: '/contact' },
]

// ── Social Links ──────────────────────────────────────────
export const SOCIAL_LINKS: SocialLink[] = [
  { platform: 'spotify', label: 'Spotify', url: 'https://open.spotify.com' },
  { platform: 'apple', label: 'Apple Music', url: 'https://music.apple.com' },
  { platform: 'soundcloud', label: 'SoundCloud', url: 'https://soundcloud.com' },
  { platform: 'mixcloud', label: 'Mixcloud', url: 'https://mixcloud.com/dj30rack' },
  { platform: 'youtube', label: 'YouTube', url: 'https://www.youtube.com/channel/UCxIbUpbL94QJWQSlF3QwTgA' },
  { platform: 'instagram', label: 'Instagram', url: 'https://www.instagram.com/dj30rack' },
  { platform: 'tiktok', label: 'TikTok', url: 'https://www.tiktok.com/@dj30rack' },
]

export const STREAMING_PLATFORMS: StreamingPlatform[] = [
  { name: 'Spotify', url: 'https://open.spotify.com' },
  { name: 'Apple Music', url: 'https://music.apple.com' },
  { name: 'SoundCloud', url: 'https://soundcloud.com' },
  { name: 'Mixcloud', url: 'https://mixcloud.com/dj30rack' },
  { name: 'YouTube', url: 'https://www.tiktok.com/@dj30rack' },
]

// ── News ──────────────────────────────────────────────────
export const NEWS_ITEMS: NewsItem[] = [
  {
    id: '1',
    date: '2026-05-12',
    title: 'New Collab Drops This Friday',
    excerpt: 'The most anticipated mashup of the summer — three years in the making and finally hitting all streaming platforms this week.',
    slug: 'new-collab-drops-friday',
    category: 'Music',
  },
  {
    id: '2',
    date: '2026-04-28',
    title: 'Stagecoach 2026 Recap',
    excerpt: 'A sold-out main stage set, a surprise guest, and a moment that nobody in that desert field will forget. Here\'s the full recap.',
    slug: 'stagecoach-2026-recap',
    category: 'Tour',
  },
  {
    id: '3',
    date: '2026-04-10',
    title: 'Syndicated Radio Show Returns for Season 4',
    excerpt: 'Friday and Saturday nights on over 80 country radio markets across America — tune in and turn it up starting May 1st.',
    slug: 'radio-show-season-4',
    category: 'News',
  },
  {
    id: '4',
    date: '2026-03-22',
    title: 'Rock The Country Tour 2026 Announced',
    excerpt: 'Hitting 24 cities across the country this summer. Full dates and ticket links are live now.',
    slug: 'rock-the-country-tour-2026',
    category: 'Tour',
  },
]

// ── Tour Dates ────────────────────────────────────────────
export const TOUR_DATES: TourDate[] = [
  {
    id: '1',
    date: '2026-06-14',
    venue: 'The Rusty Spur Saloon',
    city: 'Scottsdale',
    state: 'AZ',
    type: 'Residency Night',
    ticketUrl: '#',
  },
  {
    id: '2',
    date: '2026-06-21',
    venue: 'Country Thunder Festival',
    city: 'Twin Lakes',
    state: 'WI',
    type: 'Festival',
    ticketUrl: '#',
  },
  {
    id: '3',
    date: '2026-07-04',
    venue: 'Freedom Fest Main Stage',
    city: 'Nashville',
    state: 'TN',
    type: 'Headline',
    ticketUrl: '#',
  },
  {
    id: '4',
    date: '2026-07-19',
    venue: 'Moonshine Beach',
    city: 'San Diego',
    state: 'CA',
    type: 'Club Night',
    ticketUrl: '#',
  },
  {
    id: '5',
    date: '2026-08-02',
    venue: 'Carolina Country Music Fest',
    city: 'Myrtle Beach',
    state: 'SC',
    type: 'Festival',
    ticketUrl: '#',
  },
  {
    id: '6',
    date: '2026-08-15',
    venue: 'Barefoot Country Music Festival',
    city: 'Wildwood',
    state: 'NJ',
    type: 'Festival',
    ticketUrl: '#',
  },
  {
    id: '7',
    date: '2026-09-05',
    venue: 'Jason Aldean\'s Rooftop Bar',
    city: 'Nashville',
    state: 'TN',
    type: 'Residency Night',
    ticketUrl: '#',
  },
  {
    id: '8',
    date: '2026-09-20',
    venue: 'Gold Buckle — MGM Grand',
    city: 'Las Vegas',
    state: 'NV',
    type: 'Special Event',
    ticketUrl: '#',
  },
]

// ── Music / Releases ──────────────────────────────────────
export const TRACKS: Track[] = [
  {
    id: '1',
    title: 'Main Stage Vol. 3',
    subtitle: 'Live Mix · 2026',
    year: '2026',
    soundcloudUrl: '#',
  },
  {
    id: '2',
    title: 'Country Club EP',
    subtitle: 'Original Release · 2025',
    year: '2025',
    spotifyUrl: '#',
    appleMusicUrl: '#',
  },
  {
    id: '3',
    title: 'Late Night Drive',
    subtitle: 'Mix Tape · 2025',
    year: '2025',
    soundcloudUrl: '#',
  },
  {
    id: '4',
    title: 'Rodeo Nights Vol. 1',
    subtitle: 'Mix · 2024',
    year: '2024',
    soundcloudUrl: '#',
  },
]

// ── Videos ────────────────────────────────────────────────
export const VIDEOS: Video[] = [
  {
    id: '1',
    title: '30rack Remix | Body LIke A Backroad x Back That Azz Up',
    youtubeId: '5rzFI8QoJM0',
    date: '2026-04-28',
  },
  {
    id: '2',
    title: 'Country Thunder 2025 Highlights',
    youtubeId: 'sEBhl0xfYq0',
    date: '2025-07-22',
  },
  {
    id: '3',
    title: 'last Country San Diego tailgate',
    youtubeId: 'Z0scQsIMOEc',
    date: '2025-05-10',
  },
]

// ── Booking Event Types ───────────────────────────────────
export const BOOKING_TYPES = [
  'Festival',
  'Club / Bar Night',
  'Private Party',
  'Wedding',
  'Corporate Event',
  'Sporting Event',
  'Other',
] as const

export type BookingType = typeof BOOKING_TYPES[number]
